(() => {
  function fixBogoRow(root = document) {
    // --- Row 1: "1 - 1" -> "1" (leave price cell unchanged) ---
    const row1 = root.querySelector(
      'tbody tr.bss-b2b-qty-table-row[data-min="1"][data-max="1"]'
    );
    if (row1) {
      const qty1 = row1.querySelector("td:first-child");
      if (qty1) qty1.textContent = "1";
    }

    // --- Row 2: "2 - 2" -> "2" and prepend message above existing content in 2nd column ---
    const row2 = root.querySelector(
      'tbody tr.bss-b2b-qty-table-row[data-min="2"][data-max="2"]'
    );
    if (row2) {
      const qty2 = row2.querySelector("td:first-child");
      if (qty2) qty2.textContent = "2";

      const cell2 = row2.querySelector("td:nth-child(2)");
      if (cell2) {
        // avoid duplicating if this runs multiple times
        if (!cell2.querySelector(".bogo-note")) {
          const note = document.createElement("div");
          note.className = "bogo-note";
          note.textContent = "Buy One Get One Free";
          note.style.display = "block";
          note.style.fontWeight = "600";
          note.style.marginBottom = "4px";

          // put note above whatever is already in the cell
          cell2.prepend(note);
        }
      }
    }
  }

  // 1) Run once immediately
  fixBogoRow();

  // 2) Listen to BSS's QB table mutate DOM event
  // They dispatch this on the product form; using capture=true catches it reliably.
  document.addEventListener(
    "QB_table_mutate",
    (e) => {
      const root = e?.target instanceof Element ? e.target : document;
      fixBogoRow(root);

      // One more pass after BSS finishes any same-tick DOM writes
      queueMicrotask(() => fixBogoRow());
    },
    true
  );

  // 3) Hook into BSS's internal observer topics too, if available
  function hookBssObserver() {
    const obs = window.BSS_B2B?.observer?.productObserver;
    if (!obs || obs.__bogoRowHooked) return;
    obs.__bogoRowHooked = true;

    const run = () => fixBogoRow();

    const topics = ["QbTableMutate", "VariantChange", "QuickviewLoaded"];

    if (typeof obs.takeEvery === "function") {
      topics.forEach((topic) => {
        try {
          obs.takeEvery(topic, run, { priority: 999999, force: true });
        } catch (_) {}
      });
    } else if (typeof obs.takeLatest === "function") {
      topics.forEach((topic) => {
        try {
          obs.takeLatest(topic, run, { priority: 999999, force: true });
        } catch (_) {}
      });
    }
  }

  hookBssObserver();
  setTimeout(hookBssObserver, 250);
  setTimeout(hookBssObserver, 1000);
})();
